import React from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors } from '@mobi/component-library/Foundations'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

export const LegStatusIcon: React.FC<{
  status:
    | KambiHistoryCoupon['couponRows'][0]['status']
    | KambiHistoryCoupon['outcomes'][0]['status']
}> = ({ status }) => {
  switch (status) {
    case 'WON':
      return <Icon name='SolidCheckCircle' size='1.6rem' color={colors.success[400]} />

    case 'LOST':
      return <Icon name='SolidXCircle' size='1.6rem' color={colors.error[600]} />

    default:
      return null
  }
}
